import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthProvider";
import { hasCapability } from "@/lib/brokerAuth";
import { AccountForm } from "@/components/AccountForm";
import { createAccount } from "@/lib/brokerAccounts";
import { PageHeader } from "@/components/PageHeader";

// Add an account (BRK-S033). The broker's brokerage owns the account outright,
// so this is a plain create — no de-duplication, no attach-to-existing. On
// success we navigate to the new account. Requires account:edit; the form fields
// + pickers live in the shared AccountForm.
export function AddAccountPage() {
  const { identity, authedRequest } = useAuth();
  const canEdit = hasCapability(identity, "account:edit");
  const navigate = useNavigate();

  if (!canEdit) {
    return (
      <>
        <PageHeader title="Add account" />
        <section className="flex flex-col gap-4">
          <p role="alert" className="text-sm text-brk-danger">
            You don’t have permission to add accounts.
          </p>
          <Link
            to="/accounts"
            className="text-sm text-brk-accent hover:underline"
          >
            ← Back to accounts
          </Link>
        </section>
      </>
    );
  }

  return (
    <section>
      <PageHeader
        title="Add account"
        meta="Add an insured account for your brokerage."
      />

      <AccountForm
        submitLabel="Create account"
        pendingLabel="Creating…"
        onSubmit={async (input) => {
          const detail = await createAccount(authedRequest, input);
          navigate(`/accounts/${detail.id}`);
        }}
        cancelSlot={
          <Link
            to="/accounts"
            className="text-sm text-brk-accent hover:underline"
          >
            Cancel
          </Link>
        }
      />
    </section>
  );
}
